import ErrorText from './ErrorText';
import React from 'react';

interface IErrorComponentProps {
	message: string;
	Children: React.ReactNode;
}
interface IErrorComponentState {
	hasError: boolean;
}

class ErrorComponent extends React.Component<IErrorComponentProps, IErrorComponentState> {
	state = {
		hasError: false,
	};

	static getDerivedStateFromError(error) {
		console.log(error);
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		console.error('Something went wrong. Try again', error, info);
	}

	render() {
		const { message, children } = this.props;
		if (this.state.hasError) {
			return <ErrorText message={message} />;
		}
		return <div>{children}</div>;
	}
}

export default ErrorComponent;
